import { render } from "./DeviceView.vue?vue&type=template&id=07badeca&scoped=true"
import script from "./DeviceView.vue?vue&type=script&lang=js"
export * from "./DeviceView.vue?vue&type=script&lang=js"

import "./DeviceView.vue?vue&type=style&index=0&id=07badeca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07badeca"]])

export default __exports__